<template>
    <div>
        <answer-header type="back"></answer-header>
        <img class="logo" src="../assets/logo.png">
        <div class="que-mod">
            <table class="que-table" v-infinite-scroll="_loadMore" infinite-scroll-disabled="loading" infinite-scroll-immediate-check="false">
                <thead>
                    <tr>
                        <th>Content ID</th><th>လုပ်ဆောင်ချက်</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in list">
                        <td>{{item.code}}</td><td><div @click="_viewDoc(index)" class="btn btn-sm btn-yell">ဖတ်ရှုရန်    </div></td>
                    </tr>
                </tbody>
            </table>
        </div>

        <question></question>
    </div>
</template>

<script>
import answerHeader from './Header'
import question from './Question'
import { mapState, mapActions } from 'vuex'
import config from '../config'
export default {
    name: 'Doclist',
    components: {answerHeader, question},
    data(){
        return {
            page: 0,
            loading: false,
            list: []
        }
    },
    computed: {
        ...mapState(['lang'])
    },
    created(){
        this._loadMore();
    },
    filters: {
        statusConvert(status){
            return ''
        }
    },
    methods: {
        _loadMore(){
            // if(this.loading) return;
            this.loading = true;
            this._fetchList().done(res=>{
                if(res.code != 0){
                    this.$toast(res.msg);
                }
                else if(res.data.list.length > 0){
                    this.list = this.list.concat(res.data.list);
                }else{
                    this.$toast('no data');
                }
            }).always(()=>{
                this.loading = false;
            })
        },
        _fetchList(){
            this.page++;
            return Utils.$ajax({
                url: '/user/list&page_size=6&page_id='+this.page,
            })
        },
        _viewDoc(index){
            var item = this.list[index];
            this.$router.push(`/docinfo?id=${item.id}`);
        }
    }
}
</script>

<style lang="scss" scoped>
    .que-mod{
        width: 100%;
        height: rem(650);
        margin-bottom: rem(40);
        overflow: scroll;
    }
    .que-table{
        width: 100%;
        text-align: center;
        color: #fff;
        font-size: rem(30);
        td, th{
            border-bottom: 1px rgba(255,255,255,.6) dashed;
            padding: .8em 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Doclist.vue